import queryString from 'query-string';

const handleRequest = (url, params) => {
  const stateParams = queryString.parse(url.search);

  url.search = queryString.stringify(Object.assign({}, stateParams, params));

  window.location = url.toString();
};

const parseParamString = (paramString) => {
  const { state: queryState, ...params } = queryString.parse(paramString);

  let state;

  // Decode urlsafe base64
  if (/^b64/.test(queryState)) {
    state = atob(queryState.replace(/^b64/, '').replace(/-/g, '+').replace(/_/g, '/'));
  } else {
    state = queryState && decodeURIComponent(queryState)
  }

  return {
    state,
    params
  };
};

const parseState = (state) => {
  if (!state) {
    return {};
  }

  let fullState;
  try {
    fullState = JSON.parse(state);
  } catch (err) {
    fullState = {
      callbackUrl: state
    };
  }

  return fullState;
};

// Gallery debugger callback url
// Handle fitbit.com urls
const HTTP_PROTOCOL_REGEX = /^https?:$/;
const FITBIT_URL_REGEX = /.*\.fitbit.com$/;

// Android Webconfig callback url
// Source reference: https://source.fitbit.com/projects/ANDROID/repos/fitbitandroid/browse/platform/src/main/java/com/fitbit/platform/domain/AppSettingsContext.java
// Example: intent://appid/buildid/encodeddeviceid#Intent;scheme=fitbit;package=com.fitbit.FitbitMobile;end
const ANDROID_INTENT_HASH_REGEX = /^#Intent;scheme=fitbit;package=com\.fitbit\.(?:[a-zA-Z]+\.)?(FitbitMobile|dogebit)(?:\.[a-zA-Z]+)?;end$/;

// iOS Webconfig callback url
// Source reference: https://source.fitbit.com/projects/IOS/repos/fitbit/browse/Frameworks/JSbitKit/JSbitKit/Admin/WebconfigCallbackURLResponse.swift
// Example: fitbit://gallery/webconfig/appid/buildid/encodeddeviceid
const IOS_URL_REGEX = /^(?:dev|beta|fit|alpha|debug|dog|internal)bit(-cn)?:\/\/gallery\/webconfig\/.*$/;

const isValidCallbackUrl = ({ protocol, host, href, hash }) => {
  if (
    HTTP_PROTOCOL_REGEX.test(protocol) &&
    FITBIT_URL_REGEX.test(host) &&
    hash === '#gallery-debugger'
  ) {
    return true;
  }

  if (protocol === 'intent:' && ANDROID_INTENT_HASH_REGEX.test(hash)) {
    return true;
  }

  if (IOS_URL_REGEX.test(href)) {
    return true;
  }

  return false;
};

const handleError = (url) => {
  const root = document.getElementById('root');
  root.innerText = `Invalid callback url ${url}`;
};

(() => {
  const { state: hashState, params: hashParams } = parseParamString(window.location.hash || '');
  const { state: queryState, params: queryParams } = parseParamString(window.location.search || '');

  const state = hashState || queryState;

  const params = {
    ...hashParams,
    ...queryParams
  };

  const { callbackUrl, ...stateParams } = parseState(state);

  if (!callbackUrl) {
    handleError('');
    return;
  }

  const parsedUrl = new URL(callbackUrl);

  if (!isValidCallbackUrl(parsedUrl)) {
    handleError(callbackUrl);
    return;
  }

  if (Object.keys(stateParams).length > 0) {
    params.state = encodeURIComponent(JSON.stringify(stateParams));
  }

  handleRequest(parsedUrl, params);
})();



// WEBPACK FOOTER //
// ./src/simple-redirect.js